import { Amplify } from 'aws-amplify';
import env from './env';

const userPoolId =
  env.get('VITE_COGNITO_AUTHORITY')?.split('/').pop() ||
  'ap-south-1_NqR2GhzMF';

const userPoolClientId =
  env.get('VITE_COGNITO_FRONTEND_CLIENT_ID') ||
  '7mp489d5e948kvnkbffhskgkoe';

const cognitoDomain =
  env.get('VITE_COGNITO_DOMAIN') ||
  'bmc-dev-305137865318-auth.auth.ap-south-1.amazoncognito.com';

export function configureAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          email: true,
          oauth: {
            domain: cognitoDomain,
            scopes: ['openid', 'email'],
            redirectSignIn: [window.location.origin + '/auth/callback'],
            redirectSignOut: [window.location.origin + '/'],
            responseType: 'code',
          },
        },
      },
    },
  });
}
